import { render } from "./PerruquesItem.vue?vue&type=template&id=75e103c0&scoped=true"
import script from "./PerruquesItem.vue?vue&type=script&lang=js"
export * from "./PerruquesItem.vue?vue&type=script&lang=js"

import "./PerruquesItem.vue?vue&type=style&index=0&id=75e103c0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e103c0"]])

export default __exports__